export default __webpack_public_path__ + "static/media/about-part-1-3.ad6eb0b3.png";